<script lang="ts" generics="T extends {name?:string,label?:string}">
	export let list: T[] | undefined;
	export let genHref: (item: T) => string;
	export let noMargin = false;
</script>

<section class="brands-daisplay" class:noMargin={noMargin}>
	{#if list?.length}
		{#each list as item}
			{@const path = genHref(item)}
			<a class="label-xl ellipses" href={path}>{item.name ?? item.label ?? 'Mr D'}</a>
		{/each}
	{/if}
</section>

<style lang="scss">
	@use 'screen';

	.brands-daisplay {
		width: 100%;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: 1fr;
		grid-column-gap: 1rem;
		margin: 4rem 0;
		@media(min-width: 850px) { grid-template-columns: repeat(3, 1fr); }
		@media(screen.$md) { margin: 6rem 0; }
		@media(screen.$lg) { grid-template-columns: repeat(4, 1fr); }
		&.noMargin { margin: 0; }
		a { margin: 0 0 .65rem 0; }
	}
</style>